import F from 'offline/filter/constants'
import Util from 'offline/util'
// Port of api/fuel/app/classes/filter/package/games/game/package/users.php

function mapOrList(value) {
	return Object.keys(value || {}).length ? value : []
}

export default {
	run: function(pkg, local, global) {
		var r = local.ratings || {}
		var ratingVals = []
		var rk = Object.keys(r.users || {})
		for (var i = 0; i < rk.length; i++) if (r.users[rk[i]]) ratingVals.push(r.users[rk[i]])
		var divisiveness = 0
		if (ratingVals.length >= 2) {
			var median = Util.median(ratingVals)
			var totalDiff = 0
			for (var j = 0; j < ratingVals.length; j++) totalDiff += Math.abs(ratingVals[j] - median)
			divisiveness = Math.round((totalDiff / ratingVals.length) * 100) / 100
		}
		var played = (local.plays && local.plays.users) || {}
		var rated = {}
		for (var l = 0; l < rk.length; l++) if (r.users[rk[l]]) rated[rk[l]] = r.users[rk[l]]
		pkg.users = {
			play_last: (local.plays && local.plays.last) || 0,
			totalPlays: (local.plays && local.plays.total) || 0,
			totalDuration: (local.plays && local.plays.duration) || 0,
			totalRatings: ratingVals.length,
			totalComments: global.gameComments && global.gameComments[local.game_id] ? parseInt(global.gameComments[local.game_id].comments || 0, 10) : 0,
			played: mapOrList(played),
			rated: rated,
			status: local.status ? local.status.game : {},
			versions: mapOrList(local.versions ? local.versions.game : {}),
			parts: local.parts ? local.parts.game : [],
			wishlist: local.wishlist ? local.wishlist.game : [],
			divisiveness: divisiveness
		}
		pkg.users.rated = mapOrList(pkg.users.rated)
		return pkg
	}
}
